// DON'T EDIT. THIS FILE IS GENERATED BY ./manage.py frontend_export
// CHANGE MADES MANUALLY TO THIS FILE WILL BE LOST
// mynamespace/contribs/management/commands/frontend_export.py

const CHOICES = {
  "AccountKind": {
    "CHOICES": {
      "1": "Individual",
      "2": "Corporate"
    },
    "CHOICE_LIST": [
      {
        "label": "Individual",
        "value": 1
      },
      {
        "label": "Corporate",
        "value": 2
      }
    ],
    "CORPORATE": 2,
    "INDIVIDUAL": 1
  },
  "AccountingType": {
    "CHOICES": {
      "1": "First In First Out",
      "2": "Last In First Out"
    },
    "CHOICE_LIST": [
      {
        "label": "First In First Out",
        "value": 1
      },
      {
        "label": "Last In First Out",
        "value": 2
      }
    ],
    "FIFO": 1,
    "LIFO": 2
  },
  "ActionStatusChoices": {
    "CHOICES": {
      "0": "Save",
      "1": "Send"
    },
    "CHOICE_LIST": [
      {
        "label": "Save",
        "value": 0
      },
      {
        "label": "Send",
        "value": 1
      }
    ],
    "SAVE": 0,
    "SEND": 1
  },
  "AllocationCustodianChoices": {
    "CHOICES": {
      "1": "Kotak",
      "2": "HDFC"
    },
    "CHOICE_LIST": [
      {
        "label": "Kotak",
        "value": 1
      },
      {
        "label": "HDFC",
        "value": 2
      }
    ],
    "HDFC": 2,
    "KOTAK": 1
  },
  "AllocationFileTypeChoices": {
    "BUY_OUT_FILE": 6,
    "CHOICES": {
      "1": "FA Upload",
      "2": "Custody Upload",
      "3": "FA Out File",
      "4": "Custody Out File",
      "5": "Summary Out File",
      "6": "Buy Out File",
      "7": "Sell Out File",
      "8": "Master Sell Out File",
      "9": "Master Buy Out File"
    },
    "CHOICE_LIST": [
      {
        "label": "FA Upload",
        "value": 1
      },
      {
        "label": "Custody Upload",
        "value": 2
      },
      {
        "label": "FA Out File",
        "value": 3
      },
      {
        "label": "Custody Out File",
        "value": 4
      },
      {
        "label": "Summary Out File",
        "value": 5
      },
      {
        "label": "Buy Out File",
        "value": 6
      },
      {
        "label": "Sell Out File",
        "value": 7
      },
      {
        "label": "Master Sell Out File",
        "value": 8
      },
      {
        "label": "Master Buy Out File",
        "value": 9
      }
    ],
    "CUSTODY_OUT_FILE": 4,
    "CUSTODY_UPLOAD": 2,
    "FA_OUT_FILE": 3,
    "FA_UPLOAD": 1,
    "MASTER_BUY_OUT_FILE": 9,
    "MASTER_SELL_OUT_FILE": 8,
    "SELL_OUT_FILE": 7,
    "SUMMARY_OUT_FILE": 5
  },
  "AllocationStatusChoices": {
    "CHOICES": {
      "1": "Pending",
      "2": "Processing",
      "3": "Completed",
      "4": "Failed"
    },
    "CHOICE_LIST": [
      {
        "label": "Pending",
        "value": 1
      },
      {
        "label": "Processing",
        "value": 2
      },
      {
        "label": "Completed",
        "value": 3
      },
      {
        "label": "Failed",
        "value": 4
      }
    ],
    "COMPLETED": 3,
    "FAILED": 4,
    "PENDING": 1,
    "PROCESSING": 2
  },
  "AnalyticsStatus": {
    "ACCOUNTOPENED_FUNDING": 4,
    "CHOICES": {
      "1": "PROFILESENT_DOCUMENTSENT",
      "2": "DOCUMENTSENT_DOCUMENTRECEIVED",
      "3": "DOCUMENTRECEIVED_ACCOUNTOPENED",
      "4": "ACCOUNTOPENED_FUNDING"
    },
    "CHOICE_LIST": [
      {
        "label": "PROFILESENT_DOCUMENTSENT",
        "value": 1
      },
      {
        "label": "DOCUMENTSENT_DOCUMENTRECEIVED",
        "value": 2
      },
      {
        "label": "DOCUMENTRECEIVED_ACCOUNTOPENED",
        "value": 3
      },
      {
        "label": "ACCOUNTOPENED_FUNDING",
        "value": 4
      }
    ],
    "DOCUMENTRECEIVED_ACCOUNTOPENED": 3,
    "DOCUMENTSENT_DOCUMENTRECEIVED": 2,
    "PROFILESENT_DOCUMENTSENT": 1
  },
  "AssetKind": {
    "CASH": 2,
    "CHOICES": {
      "1": "Equity",
      "2": "Cash & Equivalent",
      "3": "Fixed Income",
      "4": "Other Assets"
    },
    "CHOICE_LIST": [
      {
        "label": "Equity",
        "value": 1
      },
      {
        "label": "Cash & Equivalent",
        "value": 2
      },
      {
        "label": "Fixed Income",
        "value": 3
      },
      {
        "label": "Other Assets",
        "value": 4
      }
    ],
    "EQUITY": 1,
    "INCOME": 3,
    "OTHER": 4
  },
  "AttachmentTypeChoices": {
    "BANK_STATEMENT_CHEQUE": 2,
    "CHOICES": {
      "0": "Generic",
      "1": "CML",
      "2": "Bank Statement or Cheque",
      "3": "PMS Agreement"
    },
    "CHOICE_LIST": [
      {
        "label": "Generic",
        "value": 0
      },
      {
        "label": "CML",
        "value": 1
      },
      {
        "label": "Bank Statement or Cheque",
        "value": 2
      },
      {
        "label": "PMS Agreement",
        "value": 3
      }
    ],
    "CML": 1,
    "GENERIC": 0,
    "PMS_AGREEMENT": 3
  },
  "AuditEntities": {
    "CHOICES": {
      "1": "Client",
      "2": "Distributor",
      "3": "User",
      "4": "Family",
      "5": "Transaction",
      "6": "Ficlient",
      "7": "REVENUE SETTINGS"
    },
    "CHOICE_LIST": [
      {
        "label": "Client",
        "value": 1
      },
      {
        "label": "Distributor",
        "value": 2
      },
      {
        "label": "User",
        "value": 3
      },
      {
        "label": "Family",
        "value": 4
      },
      {
        "label": "Transaction",
        "value": 5
      },
      {
        "label": "Ficlient",
        "value": 6
      },
      {
        "label": "REVENUE SETTINGS",
        "value": 7
      }
    ],
    "CLIENT": 1,
    "DISTRIBUTOR": 2,
    "FAMILY": 4,
    "FICLIENT": 6,
    "REVENUESETTINGS": 7,
    "TRANSACTION": 5,
    "USER": 3
  },
  "AuditReportKind": {
    "AUDITORS_COVERING_LETTER": 1,
    "BALANCE_SHEET": 3,
    "CAPITAL_GAIN_LOSS_STATEMENT": 6,
    "CHOICES": {
      "1": "Auditor's Covering Letter",
      "2": "Profit & Loss Statement",
      "3": "Balance Sheet",
      "4": "Portfolio Factsheet",
      "5": "Transaction Statement",
      "6": "Capital Gain Loss Statement",
      "7": "Statement of Dividend",
      "8": "Statement of Interest",
      "9": "Statement of Expense",
      "10": "Notes to accounts",
      "11": "Itus's Covering Letter",
      "12": "Merged Audit Report"
    },
    "CHOICE_LIST": [
      {
        "label": "Auditor's Covering Letter",
        "value": 1
      },
      {
        "label": "Profit & Loss Statement",
        "value": 2
      },
      {
        "label": "Balance Sheet",
        "value": 3
      },
      {
        "label": "Portfolio Factsheet",
        "value": 4
      },
      {
        "label": "Transaction Statement",
        "value": 5
      },
      {
        "label": "Capital Gain Loss Statement",
        "value": 6
      },
      {
        "label": "Statement of Dividend",
        "value": 7
      },
      {
        "label": "Statement of Interest",
        "value": 8
      },
      {
        "label": "Statement of Expense",
        "value": 9
      },
      {
        "label": "Notes to accounts",
        "value": 10
      },
      {
        "label": "Itus's Covering Letter",
        "value": 11
      },
      {
        "label": "Merged Audit Report",
        "value": 12
      }
    ],
    "ITUS_COVERING_LETTER": 11,
    "MERGED_AUDIT_REPORT": 12,
    "NOTES_TO_ACCOUNTS": 10,
    "PORTFOLIO_FACTSHEET": 4,
    "PROFIT_AND_LOSS_STATEMENT": 2,
    "STATEMENT_OF_DIVIDEND": 7,
    "STATEMENT_OF_EXPENSE": 9,
    "STATEMENT_OF_INTEREST": 8,
    "TRANSACTION_STATEMENT": 5
  },
  "ClientAuditReportMailerStatus": {
    "CHOICES": {
      "1": "Registered",
      "2": "Intiated",
      "3": "Sent",
      "4": "Notsent"
    },
    "CHOICE_LIST": [
      {
        "label": "Registered",
        "value": 1
      },
      {
        "label": "Intiated",
        "value": 2
      },
      {
        "label": "Sent",
        "value": 3
      },
      {
        "label": "Notsent",
        "value": 4
      }
    ],
    "INITIATED": 2,
    "NOT_SENT": 4,
    "REGISTERED": 1,
    "SENT": 3
  },
  "ClientRedemptionStatusChoices": {
    "APPROVED": 4,
    "CANCELLED": 6,
    "CHOICES": {
      "0": "Pending",
      "1": "Sent",
      "2": "Recieved",
      "3": "Initiated",
      "4": "Approved",
      "5": "Rejected",
      "6": "Cancelled",
      "7": "Settled",
      "8": "Completed"
    },
    "CHOICE_LIST": [
      {
        "label": "Pending",
        "value": 0
      },
      {
        "label": "Sent",
        "value": 1
      },
      {
        "label": "Recieved",
        "value": 2
      },
      {
        "label": "Initiated",
        "value": 3
      },
      {
        "label": "Approved",
        "value": 4
      },
      {
        "label": "Rejected",
        "value": 5
      },
      {
        "label": "Cancelled",
        "value": 6
      },
      {
        "label": "Settled",
        "value": 7
      },
      {
        "label": "Completed",
        "value": 8
      }
    ],
    "COMPLETED": 8,
    "INITIATED": 3,
    "PENDING": 0,
    "RECEIVED": 2,
    "REJECTED": 5,
    "SENT": 1,
    "SETTLED": 7
  },
  "ClientReports": {
    "CHOICES": {
      "1": "Fact Sheet",
      "2": "Taxation Reports",
      "3": "Transaction Details"
    },
    "CHOICE_LIST": [
      {
        "label": "Fact Sheet",
        "value": 1
      },
      {
        "label": "Taxation Reports",
        "value": 2
      },
      {
        "label": "Transaction Details",
        "value": 3
      }
    ],
    "FACTSHEET": 1,
    "TAXATION_REPORTS": 2,
    "TRANSACTION_DETAILS": 3
  },
  "ClientTypeChoices": {
    "CHOICES": {
      "1": "RESIDENT",
      "2": "NRE",
      "3": "NRO",
      "4": "CORPORATE"
    },
    "CHOICE_LIST": [
      {
        "label": "RESIDENT",
        "value": 1
      },
      {
        "label": "NRE",
        "value": 2
      },
      {
        "label": "NRO",
        "value": 3
      },
      {
        "label": "CORPORATE",
        "value": 4
      }
    ],
    "CORPORATE": 4,
    "NRE": 2,
    "NRO": 3,
    "RESIDENT": 1
  },
  "CustodianChoices": {
    "CHOICES": {
      "1": "Kotak",
      "2": "HDFC"
    },
    "CHOICE_LIST": [
      {
        "label": "Kotak",
        "value": 1
      },
      {
        "label": "HDFC",
        "value": 2
      }
    ],
    "HDFC": 2,
    "KOTAK": 1
  },
  "DailyReports": {
    "AMC_LEVEL_NAV": 1,
    "CHOICES": {
      "1": "AMC LEVEL NAV",
      "2": "Portfolio Summary With Security Percentage",
      "3": "Holding Client",
      "4": "Transaction Report Client",
      "5": "Trial Balance Client",
      "6": "Portfolio Fact Sheet",
      "7": "Holding Client BQ",
      "8": "Holding Global BQ",
      "9": "Portfolio PerfSummary Client"
    },
    "CHOICE_LIST": [
      {
        "label": "AMC LEVEL NAV",
        "value": 1
      },
      {
        "label": "Portfolio Summary With Security Percentage",
        "value": 2
      },
      {
        "label": "Holding Client",
        "value": 3
      },
      {
        "label": "Transaction Report Client",
        "value": 4
      },
      {
        "label": "Trial Balance Client",
        "value": 5
      },
      {
        "label": "Portfolio Fact Sheet",
        "value": 6
      },
      {
        "label": "Holding Client BQ",
        "value": 7
      },
      {
        "label": "Holding Global BQ",
        "value": 8
      },
      {
        "label": "Portfolio PerfSummary Client",
        "value": 9
      }
    ],
    "HOLDING_CLIENT": 3,
    "HOLDING_CLIENT_BQ": 7,
    "HOLDING_GLOBAL_BQ": 8,
    "PORTFOLIO_FACT_SHEET": 6,
    "PORTFOLIO_PERFSUMMARY_CLIENT": 9,
    "PORTFOLIO_SUMMARY_WITH_SECURITY_PERCENTAGE": 2,
    "TRANSACTION_REPORT_CLIENT": 4,
    "TRIAL_BALANCE_CLIENT": 5
  },
  "EmailDeliveryStatusChoices": {
    "CHOICES": {
      "0": "Pending",
      "1": "Sent",
      "2": "Failed",
      "3": "Rejected",
      "4": "Received",
      "5": "Opened",
      "6": "Clicked"
    },
    "CHOICE_LIST": [
      {
        "label": "Pending",
        "value": 0
      },
      {
        "label": "Sent",
        "value": 1
      },
      {
        "label": "Failed",
        "value": 2
      },
      {
        "label": "Rejected",
        "value": 3
      },
      {
        "label": "Received",
        "value": 4
      },
      {
        "label": "Opened",
        "value": 5
      },
      {
        "label": "Clicked",
        "value": 6
      }
    ],
    "CLICKED": 6,
    "FAILED": 2,
    "OPENED": 5,
    "PENDING": 0,
    "RECEIVED": 4,
    "REJECTED": 3,
    "SENT": 1
  },
  "EmailTrackingStatus": {
    "CHOICES": {
      "1": "Yes",
      "2": "No",
      "3": "Not Required"
    },
    "CHOICE_LIST": [
      {
        "label": "Yes",
        "value": 1
      },
      {
        "label": "No",
        "value": 2
      },
      {
        "label": "Not Required",
        "value": 3
      }
    ],
    "NO": 2,
    "NOT_REQUIRED": 3,
    "YES": 1
  },
  "FileTypeChoices": {
    "APPROVAL_FILES": 6,
    "CHOICES": {
      "1": "Kotak Holdings",
      "2": "HDFC Holdings",
      "3": "Trade Master",
      "4": "Client Master",
      "5": "Stock Master",
      "6": "Approval Files",
      "7": "Kotak Settlement",
      "8": "Hdfc Settlement",
      "9": "Client Top Up Buy",
      "10": "Client Partial Sell"
    },
    "CHOICE_LIST": [
      {
        "label": "Kotak Holdings",
        "value": 1
      },
      {
        "label": "HDFC Holdings",
        "value": 2
      },
      {
        "label": "Trade Master",
        "value": 3
      },
      {
        "label": "Client Master",
        "value": 4
      },
      {
        "label": "Stock Master",
        "value": 5
      },
      {
        "label": "Approval Files",
        "value": 6
      },
      {
        "label": "Kotak Settlement",
        "value": 7
      },
      {
        "label": "Hdfc Settlement",
        "value": 8
      },
      {
        "label": "Client Top Up Buy",
        "value": 9
      },
      {
        "label": "Client Partial Sell",
        "value": 10
      }
    ],
    "CLIENT_MASTER": 4,
    "CLIENT_PARTIAL_SELL": 10,
    "CLIENT_TOP_UP_BUY": 9,
    "HDFC_HOLDINGS": 2,
    "HDFC_SETTLEMENT": 8,
    "KOTAK_HOLDINGS": 1,
    "KOTAK_SETTLEMENT": 7,
    "STOCK_MASTER": 5,
    "TRADE_MASTER": 3
  },
  "FinanceKind": {
    "CASH": 2,
    "CHOICES": {
      "1": "Stock",
      "2": "Cash",
      "3": "Stock & Cash"
    },
    "CHOICE_LIST": [
      {
        "label": "Stock",
        "value": 1
      },
      {
        "label": "Cash",
        "value": 2
      },
      {
        "label": "Stock & Cash",
        "value": 3
      }
    ],
    "STOCK": 1,
    "STOCK_CASH": 3
  },
  "Frequency": {
    "ANNIVERSARY": 5,
    "ANNUAL": 4,
    "CHOICES": {
      "1": "Monthly",
      "2": "Quarterly",
      "3": "Half Yearly",
      "4": "Annual",
      "5": "Anniversary"
    },
    "CHOICE_LIST": [
      {
        "label": "Monthly",
        "value": 1
      },
      {
        "label": "Quarterly",
        "value": 2
      },
      {
        "label": "Half Yearly",
        "value": 3
      },
      {
        "label": "Annual",
        "value": 4
      },
      {
        "label": "Anniversary",
        "value": 5
      }
    ],
    "HALFYEARLY": 3,
    "MONTHLY": 1,
    "QUARTERLY": 2
  },
  "GenderChoices": {
    "CHOICES": {
      "1": "M",
      "2": "F",
      "3": "O"
    },
    "CHOICE_LIST": [
      {
        "label": "M",
        "value": 1
      },
      {
        "label": "F",
        "value": 2
      },
      {
        "label": "O",
        "value": 3
      }
    ],
    "FEMALE": 2,
    "MALE": 1,
    "OTHER": 3
  },
  "MISMailerStatus": {
    "CHOICES": {
      "1": "Registered",
      "2": "Intiated",
      "3": "Sent",
      "4": "Notsent"
    },
    "CHOICE_LIST": [
      {
        "label": "Registered",
        "value": 1
      },
      {
        "label": "Intiated",
        "value": 2
      },
      {
        "label": "Sent",
        "value": 3
      },
      {
        "label": "Notsent",
        "value": 4
      }
    ],
    "INITIATED": 2,
    "NOT_SENT": 4,
    "REGISTERED": 1,
    "SENT": 3
  },
  "MailerTypeChoices": {
    "CHOICES": {
      "0": "Generic",
      "1": "Fund Request",
      "2": "Fund Acknowledgement",
      "3": "PMS Agreement",
      "4": "Onboarding",
      "5": "Client Closure Acknowledgement",
      "6": "Client Redemption Form",
      "7": "Client Redemption Settlement Partial",
      "8": "Client Redemption Settlement Full",
      "9": "Redemption Initiated",
      "10": "Redemption Approved",
      "11": "Redemption Rejected",
      "12": "Redemption Cancelled",
      "13": "Redemption Settled",
      "14": "Fund Transfer Instruction",
      "15": "FA Instruction",
      "16": "Partial FA Instruction",
      "17": "Trade Generation Fund Manager",
      "18": "Trade Generation Broker",
      "19": "Trade Allocation FA",
      "20": "Trade Allocation Custody",
      "21": "Switch Instruction"
    },
    "CHOICE_LIST": [
      {
        "label": "Generic",
        "value": 0
      },
      {
        "label": "Fund Request",
        "value": 1
      },
      {
        "label": "Fund Acknowledgement",
        "value": 2
      },
      {
        "label": "PMS Agreement",
        "value": 3
      },
      {
        "label": "Onboarding",
        "value": 4
      },
      {
        "label": "Client Closure Acknowledgement",
        "value": 5
      },
      {
        "label": "Client Redemption Form",
        "value": 6
      },
      {
        "label": "Client Redemption Settlement Partial",
        "value": 7
      },
      {
        "label": "Client Redemption Settlement Full",
        "value": 8
      },
      {
        "label": "Redemption Initiated",
        "value": 9
      },
      {
        "label": "Redemption Approved",
        "value": 10
      },
      {
        "label": "Redemption Rejected",
        "value": 11
      },
      {
        "label": "Redemption Cancelled",
        "value": 12
      },
      {
        "label": "Redemption Settled",
        "value": 13
      },
      {
        "label": "Fund Transfer Instruction",
        "value": 14
      },
      {
        "label": "FA Instruction",
        "value": 15
      },
      {
        "label": "Partial FA Instruction",
        "value": 16
      },
      {
        "label": "Trade Generation Fund Manager",
        "value": 17
      },
      {
        "label": "Trade Generation Broker",
        "value": 18
      },
      {
        "label": "Trade Allocation FA",
        "value": 19
      },
      {
        "label": "Trade Allocation Custody",
        "value": 20
      },
      {
        "label": "Switch Instruction",
        "value": 21
      }
    ],
    "CLIENT_CLOSURE_ACKNOWLEDGEMENT": 5,
    "CLIENT_REDEMPTION_FORM": 6,
    "CLIENT_REDEMPTION_SETTLEMENT": 7,
    "CLIENT_REDEMPTION_SETTLEMENT_FULL": 8,
    "FA_INSTRUCTION": 15,
    "FUND_ACKNOWLEDGEMENT": 2,
    "FUND_REQUEST": 1,
    "FUND_TRANSFER_INSTRUCTION": 14,
    "GENERIC": 0,
    "ONBOARDING": 4,
    "PARTIAL_FA_INSTRUCTION": 16,
    "PMS_AGREEMENT": 3,
    "REDEMPTION_APPROVED": 10,
    "REDEMPTION_CANCELLED": 12,
    "REDEMPTION_INITIATED": 9,
    "REDEMPTION_REJECTED": 11,
    "REDEMPTION_SETTLED": 13,
    "SWITCH_INSTRUCTION": 21,
    "TRADE_ALLOCATION_CUSTODY": 20,
    "TRADE_ALLOCATION_FA": 19,
    "TRADE_GEN_BROKER": 18,
    "TRADE_GEN_FUND_MANAGER": 17
  },
  "MarketCap": {
    "CHOICES": {
      "1": "Large",
      "2": "Mid",
      "3": "Small"
    },
    "CHOICE_LIST": [
      {
        "label": "Large",
        "value": 1
      },
      {
        "label": "Mid",
        "value": 2
      },
      {
        "label": "Small",
        "value": 3
      }
    ],
    "LARGE": 1,
    "MID": 2,
    "SMALL": 3
  },
  "ModeKind": {
    "CASH": 1,
    "CHOICES": {
      "1": "Cash",
      "2": "Stock"
    },
    "CHOICE_LIST": [
      {
        "label": "Cash",
        "value": 1
      },
      {
        "label": "Stock",
        "value": 2
      }
    ],
    "STOCK": 2
  },
  "ModeOfOperationChoices": {
    "CHOICES": {
      "1": "SINGLE",
      "2": "EITHER_OR_SURVIVOR",
      "3": "JOINT"
    },
    "CHOICE_LIST": [
      {
        "label": "SINGLE",
        "value": 1
      },
      {
        "label": "EITHER_OR_SURVIVOR",
        "value": 2
      },
      {
        "label": "JOINT",
        "value": 3
      }
    ],
    "EITHER_OR_SURVIVOR": 2,
    "JOINT": 3,
    "SINGLE": 1
  },
  "Nationality": {
    "CHOICES": {
      "1": "Resident",
      "2": "NRI"
    },
    "CHOICE_LIST": [
      {
        "label": "Resident",
        "value": 1
      },
      {
        "label": "NRI",
        "value": 2
      }
    ],
    "NRI": 2,
    "RESIDENT": 1
  },
  "NewprospectStatus": {
    "ACCOUNTOPENED": 3,
    "CHOICES": {
      "1": "WAITINGFORPROFILE",
      "2": "WAITINGFORDOCUMENT",
      "3": "ACCOUNTOPENED",
      "4": "FUNDING",
      "5": "COMPLETE",
      "6": "LOST"
    },
    "CHOICE_LIST": [
      {
        "label": "WAITINGFORPROFILE",
        "value": 1
      },
      {
        "label": "WAITINGFORDOCUMENT",
        "value": 2
      },
      {
        "label": "ACCOUNTOPENED",
        "value": 3
      },
      {
        "label": "FUNDING",
        "value": 4
      },
      {
        "label": "COMPLETE",
        "value": 5
      },
      {
        "label": "LOST",
        "value": 6
      }
    ],
    "COMPLETE": 5,
    "FUNDING": 4,
    "LOST": 6,
    "WAITINGFORDOCUMENT": 2,
    "WAITINGFORPROFILE": 1
  },
  "PortfolioKind": {
    "CHOICES": {
      "1": "Equity",
      "2": "Discretionary",
      "3": "Non-Discretionary"
    },
    "CHOICE_LIST": [
      {
        "label": "Equity",
        "value": 1
      },
      {
        "label": "Discretionary",
        "value": 2
      },
      {
        "label": "Non-Discretionary",
        "value": 3
      }
    ],
    "DISCRETIONARY": 2,
    "EQUITY": 1,
    "NONDISCRETIONARY": 3
  },
  "ProspectStatus": {
    "CHOICES": {
      "1": "Open",
      "2": "Won",
      "3": "Lost"
    },
    "CHOICE_LIST": [
      {
        "label": "Open",
        "value": 1
      },
      {
        "label": "Won",
        "value": 2
      },
      {
        "label": "Lost",
        "value": 3
      }
    ],
    "LOST": 3,
    "OPEN": 1,
    "WON": 2
  },
  "ProspectStatus1": {
    "ACCOUNTOPENED": 3,
    "CHOICES": {
      "1": "WAITINGFORPROFILE",
      "2": "WAITINGFORDOCUMENTS",
      "3": "ACCOUNTOPENED",
      "4": "FUNDING",
      "5": "COMPLETE"
    },
    "CHOICE_LIST": [
      {
        "label": "WAITINGFORPROFILE",
        "value": 1
      },
      {
        "label": "WAITINGFORDOCUMENTS",
        "value": 2
      },
      {
        "label": "ACCOUNTOPENED",
        "value": 3
      },
      {
        "label": "FUNDING",
        "value": 4
      },
      {
        "label": "COMPLETE",
        "value": 5
      }
    ],
    "COMPLETE": 5,
    "FUNDING": 4,
    "WAITINGFORDOCUMENTS": 2,
    "WAITINGFORPROFILE": 1
  },
  "Quarter": {
    "CHOICES": {
      "1": "Q1 (Apr - Jun)",
      "2": "Q2 (Jul - Sep)",
      "3": "Q3 (Oct - Dec)",
      "4": "Q4 (Jan - Mar)"
    },
    "CHOICE_LIST": [
      {
        "label": "Q1 (Apr - Jun)",
        "value": 1
      },
      {
        "label": "Q2 (Jul - Sep)",
        "value": 2
      },
      {
        "label": "Q3 (Oct - Dec)",
        "value": 3
      },
      {
        "label": "Q4 (Jan - Mar)",
        "value": 4
      }
    ],
    "Q1": 1,
    "Q2": 2,
    "Q3": 3,
    "Q4": 4
  },
  "RedemptionAccountTypeChoices": {
    "CHOICES": {
      "1": "Pool",
      "2": "Non Pool"
    },
    "CHOICE_LIST": [
      {
        "label": "Pool",
        "value": 1
      },
      {
        "label": "Non Pool",
        "value": 2
      }
    ],
    "NON_POOL": 2,
    "POOL": 1
  },
  "RedemptionDocumentTypeChoices": {
    "CHOICES": {
      "1": "Redemption Document Unsigned",
      "2": "Redemption Document Signed",
      "3": "Redemption Document Bank Book",
      "4": "Redemption Mailer Document",
      "5": "Redemption Fund Transfer Instruction",
      "6": "Redemption FA Instruction",
      "7": "Redemption Partial FA Instruction"
    },
    "CHOICE_LIST": [
      {
        "label": "Redemption Document Unsigned",
        "value": 1
      },
      {
        "label": "Redemption Document Signed",
        "value": 2
      },
      {
        "label": "Redemption Document Bank Book",
        "value": 3
      },
      {
        "label": "Redemption Mailer Document",
        "value": 4
      },
      {
        "label": "Redemption Fund Transfer Instruction",
        "value": 5
      },
      {
        "label": "Redemption FA Instruction",
        "value": 6
      },
      {
        "label": "Redemption Partial FA Instruction",
        "value": 7
      }
    ],
    "REDEMPTION_DOCUMENT_BANK_BOOK": 3,
    "REDEMPTION_DOCUMENT_SIGNED": 2,
    "REDEMPTION_DOCUMENT_UNSIGNED": 1,
    "REDEMPTION_FA_INSTRUCTION": 6,
    "REDEMPTION_FUND_TRANSFER_INSTRUCTION": 5,
    "REDEMPTION_MAILER_DOCUMENT": 4,
    "REDEMPTION_PARTIAL_FA_INSTRUCTION": 7
  },
  "RedemptionKind": {
    "CHOICES": {
      "1": "Partial",
      "2": "Full"
    },
    "CHOICE_LIST": [
      {
        "label": "Partial",
        "value": 1
      },
      {
        "label": "Full",
        "value": 2
      }
    ],
    "FULL": 2,
    "PARTIAL": 1
  },
  "RevenueShareTypeChoices": {
    "CHOICES": {
      "1": "Initial Inflow",
      "2": "Top Up",
      "3": "Partial Redemption",
      "4": "Redemption",
      "5": "Gain/Loss"
    },
    "CHOICE_LIST": [
      {
        "label": "Initial Inflow",
        "value": 1
      },
      {
        "label": "Top Up",
        "value": 2
      },
      {
        "label": "Partial Redemption",
        "value": 3
      },
      {
        "label": "Redemption",
        "value": 4
      },
      {
        "label": "Gain/Loss",
        "value": 5
      }
    ],
    "GAIN_OR_LOSS": 5,
    "INITIAL_INFLOW": 1,
    "PARTIAL_REDEMPTION": 3,
    "REDEMPTION": 4,
    "TOP_UP": 2
  },
  "SecurityTransactionAssetType": {
    "CHOICES": {
      "1": "Shares",
      "2": "Mutual Funds",
      "3": "Other Assets"
    },
    "CHOICE_LIST": [
      {
        "label": "Shares",
        "value": 1
      },
      {
        "label": "Mutual Funds",
        "value": 2
      },
      {
        "label": "Other Assets",
        "value": 3
      }
    ],
    "MUTUAL_FUNDS": 2,
    "OTHER_ASSETS": 3,
    "SHARES": 1
  },
  "ServiceRequestStatusChoices": {
    "CHOICES": {
      "1": "PENDING",
      "2": "IN_PROGRESS",
      "3": "COMPLETED",
      "4": "REJECTED"
    },
    "CHOICE_LIST": [
      {
        "label": "PENDING",
        "value": 1
      },
      {
        "label": "IN_PROGRESS",
        "value": 2
      },
      {
        "label": "COMPLETED",
        "value": 3
      },
      {
        "label": "REJECTED",
        "value": 4
      }
    ],
    "COMPLETED": 3,
    "IN_PROGRESS": 2,
    "PENDING": 1,
    "REJECTED": 4
  },
  "ServiceRequestTypeChoices": {
    "ACCOUNT_CLOSURE": 10,
    "CHANGE_IN_ADDRESS": 6,
    "CHANGE_IN_BANK": 7,
    "CHANGE_IN_BROKER": 5,
    "CHANGE_IN_MOBILE_NUMBER": 2,
    "CHANGE_IN_NOMINEE": 8,
    "CHOICES": {
      "1": "EMAIL_ID_UPDATION",
      "2": "CHANGE_IN_MOBILE_NUMBER",
      "3": "NAME_CHANGE",
      "4": "RESIDENT_STATUS_CHANGE",
      "5": "CHANGE_IN_BROKER",
      "6": "CHANGE_IN_ADDRESS",
      "7": "CHANGE_IN_BANK",
      "8": "CHANGE_IN_NOMINEE",
      "9": "MINOR_NOMINEE_GUARDIAN_CHANGE",
      "10": "ACCOUNT_CLOSURE",
      "11": "NOMINEE_ADDRESS_CHANGE",
      "12": "NOMINEE_MOBILE_NUMBER_CHANGE",
      "13": "NOMINEE_EMAIL_ID_CHANGE"
    },
    "CHOICE_LIST": [
      {
        "label": "EMAIL_ID_UPDATION",
        "value": 1
      },
      {
        "label": "CHANGE_IN_MOBILE_NUMBER",
        "value": 2
      },
      {
        "label": "NAME_CHANGE",
        "value": 3
      },
      {
        "label": "RESIDENT_STATUS_CHANGE",
        "value": 4
      },
      {
        "label": "CHANGE_IN_BROKER",
        "value": 5
      },
      {
        "label": "CHANGE_IN_ADDRESS",
        "value": 6
      },
      {
        "label": "CHANGE_IN_BANK",
        "value": 7
      },
      {
        "label": "CHANGE_IN_NOMINEE",
        "value": 8
      },
      {
        "label": "MINOR_NOMINEE_GUARDIAN_CHANGE",
        "value": 9
      },
      {
        "label": "ACCOUNT_CLOSURE",
        "value": 10
      },
      {
        "label": "NOMINEE_ADDRESS_CHANGE",
        "value": 11
      },
      {
        "label": "NOMINEE_MOBILE_NUMBER_CHANGE",
        "value": 12
      },
      {
        "label": "NOMINEE_EMAIL_ID_CHANGE",
        "value": 13
      }
    ],
    "EMAIL_ID_UPDATION": 1,
    "MINOR_NOMINEE_GUARDIAN_CHANGE": 9,
    "NAME_CHANGE": 3,
    "NOMINEE_ADDRESS_CHANGE": 11,
    "NOMINEE_EMAIL_ID_CHANGE": 13,
    "NOMINEE_MOBILE_NUMBER_CHANGE": 12,
    "RESIDENT_STATUS_CHANGE": 4
  },
  "SwitchInstructionGeneratingStatusChoices": {
    "CHOICES": {
      "0": "Generating",
      "2": "Generated",
      "3": "Failed",
      "4": "Completed"
    },
    "CHOICE_LIST": [
      {
        "label": "Generating",
        "value": 0
      },
      {
        "label": "Generated",
        "value": 2
      },
      {
        "label": "Failed",
        "value": 3
      },
      {
        "label": "Completed",
        "value": 4
      }
    ],
    "Completed": 4,
    "Failed": 3,
    "GENERATED": 2,
    "Generating": 0
  },
  "SwitchInstructionStatusChoices": {
    "APPROVED": 3,
    "CHOICES": {
      "0": "Draft",
      "1": "Review",
      "2": "Rejected",
      "3": "Approved",
      "4": "Generated",
      "5": "Sent"
    },
    "CHOICE_LIST": [
      {
        "label": "Draft",
        "value": 0
      },
      {
        "label": "Review",
        "value": 1
      },
      {
        "label": "Rejected",
        "value": 2
      },
      {
        "label": "Approved",
        "value": 3
      },
      {
        "label": "Generated",
        "value": 4
      },
      {
        "label": "Sent",
        "value": 5
      }
    ],
    "DRAFT": 0,
    "GENERATED": 4,
    "REJECTED": 2,
    "REVIEW": 1,
    "SENT": 5
  },
  "TaxSlab": {
    "CHOICES": {
      "1": "Senior Citizen",
      "2": "Individual",
      "3": "Corporate"
    },
    "CHOICE_LIST": [
      {
        "label": "Senior Citizen",
        "value": 1
      },
      {
        "label": "Individual",
        "value": 2
      },
      {
        "label": "Corporate",
        "value": 3
      }
    ],
    "CORPORATE": 3,
    "INDIVIDUAL": 2,
    "SENIOR_CITIZEN": 1
  },
  "TaxationOptions": {
    "CHOICES": {
      "1": "Q1 (Apr - Jun)",
      "2": "Q2 (Jul - Sep)",
      "3": "Q3 (Oct - Dec)",
      "4": "Q4 (Jan - Mar)",
      "5": "Advance Taxes"
    },
    "CHOICE_LIST": [
      {
        "label": "Q1 (Apr - Jun)",
        "value": 1
      },
      {
        "label": "Q2 (Jul - Sep)",
        "value": 2
      },
      {
        "label": "Q3 (Oct - Dec)",
        "value": 3
      },
      {
        "label": "Q4 (Jan - Mar)",
        "value": 4
      },
      {
        "label": "Advance Taxes",
        "value": 5
      }
    ],
    "Q1": 1,
    "Q2": 2,
    "Q3": 3,
    "Q4": 4,
    "Q5": 5
  },
  "TaxationUploadKind": {
    "CAPITAL_GAIN_LOSS": 1,
    "CHOICES": {
      "1": "Capital Gain/Loss Statement",
      "2": "Interests Statement",
      "3": "Dividends Statement",
      "4": "PMS Investor Report"
    },
    "CHOICE_LIST": [
      {
        "label": "Capital Gain/Loss Statement",
        "value": 1
      },
      {
        "label": "Interests Statement",
        "value": 2
      },
      {
        "label": "Dividends Statement",
        "value": 3
      },
      {
        "label": "PMS Investor Report",
        "value": 4
      }
    ],
    "DIVIDEND_STATEMENT": 3,
    "INTEREST_STATEMENT": 2,
    "PMS_INVESTOR_REPORT": 4
  },
  "TradeActivityActionChoices": {
    "APPROVE": 5,
    "CANCEL": 7,
    "CHOICES": {
      "1": "Create",
      "2": "Update",
      "3": "Delete",
      "4": "Process",
      "5": "Approve",
      "6": "Reject",
      "7": "Cancel",
      "8": "Execute",
      "9": "Upload",
      "10": "Download",
      "11": "View"
    },
    "CHOICE_LIST": [
      {
        "label": "Create",
        "value": 1
      },
      {
        "label": "Update",
        "value": 2
      },
      {
        "label": "Delete",
        "value": 3
      },
      {
        "label": "Process",
        "value": 4
      },
      {
        "label": "Approve",
        "value": 5
      },
      {
        "label": "Reject",
        "value": 6
      },
      {
        "label": "Cancel",
        "value": 7
      },
      {
        "label": "Execute",
        "value": 8
      },
      {
        "label": "Upload",
        "value": 9
      },
      {
        "label": "Download",
        "value": 10
      },
      {
        "label": "View",
        "value": 11
      }
    ],
    "CREATE": 1,
    "DELETE": 3,
    "DOWNLOAD": 10,
    "EXECUTE": 8,
    "PROCESS": 4,
    "REJECT": 6,
    "UPDATE": 2,
    "UPLOAD": 9,
    "VIEW": 11
  },
  "TradeBuySchemeChoices": {
    "CHOICES": {
      "1": "FVF",
      "2": "Shariah",
      "3": "NDPMS",
      "4": "6 Stocks"
    },
    "CHOICE_LIST": [
      {
        "label": "FVF",
        "value": 1
      },
      {
        "label": "Shariah",
        "value": 2
      },
      {
        "label": "NDPMS",
        "value": 3
      },
      {
        "label": "6 Stocks",
        "value": 4
      }
    ],
    "FVF": 1,
    "NDPMS": 3,
    "SHARIAH": 2,
    "SIX_STOCKS": 4
  },
  "TradeBuyStrategyChoices": {
    "ALLOCATE": 2,
    "CHOICES": {
      "1": "Ramp Up",
      "2": "Allocate"
    },
    "CHOICE_LIST": [
      {
        "label": "Ramp Up",
        "value": 1
      },
      {
        "label": "Allocate",
        "value": 2
      }
    ],
    "RAMP_UP": 1
  },
  "TradeGenerationReportChoices": {
    "BROKER_FILE": 4,
    "CHOICES": {
      "1": "Processed File",
      "2": "Rejected File",
      "3": "Ignored Clients File",
      "4": "Broker File"
    },
    "CHOICE_LIST": [
      {
        "label": "Processed File",
        "value": 1
      },
      {
        "label": "Rejected File",
        "value": 2
      },
      {
        "label": "Ignored Clients File",
        "value": 3
      },
      {
        "label": "Broker File",
        "value": 4
      }
    ],
    "IGNORED_CLIENTS_FILE": 3,
    "PROCESSING_FILE": 1,
    "REJECTED_FILE": 2
  },
  "TradeGenerationStatusChoices": {
    "APPROVED": 8,
    "CANCELLED": 6,
    "CHOICES": {
      "1": "Pending",
      "2": "Processing",
      "3": "Completed",
      "4": "Failed",
      "5": "Error",
      "6": "Cancelled",
      "7": "Executed",
      "8": "Approved"
    },
    "CHOICE_LIST": [
      {
        "label": "Pending",
        "value": 1
      },
      {
        "label": "Processing",
        "value": 2
      },
      {
        "label": "Completed",
        "value": 3
      },
      {
        "label": "Failed",
        "value": 4
      },
      {
        "label": "Error",
        "value": 5
      },
      {
        "label": "Cancelled",
        "value": 6
      },
      {
        "label": "Executed",
        "value": 7
      },
      {
        "label": "Approved",
        "value": 8
      }
    ],
    "COMPLETED": 3,
    "ERROR": 5,
    "EXECUTED": 7,
    "FAILED": 4,
    "PENDING": 1,
    "PROCESSING": 2
  },
  "TradeLevelChoices": {
    "CHOICES": {
      "1": "Firm Level",
      "2": "Client Level",
      "3": "Switch"
    },
    "CHOICE_LIST": [
      {
        "label": "Firm Level",
        "value": 1
      },
      {
        "label": "Client Level",
        "value": 2
      },
      {
        "label": "Switch",
        "value": 3
      }
    ],
    "CLIENT_LEVEL": 2,
    "FIRM_LEVEL": 1,
    "SWITCH": 3
  },
  "TradeSellTypeChoices": {
    "CHOICES": {
      "1": "Reduce To Percentage",
      "2": "Rebalance To Value",
      "3": "Sell Fixed Value"
    },
    "CHOICE_LIST": [
      {
        "label": "Reduce To Percentage",
        "value": 1
      },
      {
        "label": "Rebalance To Value",
        "value": 2
      },
      {
        "label": "Sell Fixed Value",
        "value": 3
      }
    ],
    "REBALANCE_TO_VALUE": 2,
    "REDUCE_TO_PERCENTAGE": 1,
    "SELL_FIXED_VALUE": 3
  },
  "TradeStatusChoices": {
    "APPROVED": 2,
    "CANCELLED": 4,
    "CHOICES": {
      "1": "Pending",
      "2": "Approved",
      "3": "Rejected",
      "4": "Cancelled",
      "5": "Executed",
      "6": "Error"
    },
    "CHOICE_LIST": [
      {
        "label": "Pending",
        "value": 1
      },
      {
        "label": "Approved",
        "value": 2
      },
      {
        "label": "Rejected",
        "value": 3
      },
      {
        "label": "Cancelled",
        "value": 4
      },
      {
        "label": "Executed",
        "value": 5
      },
      {
        "label": "Error",
        "value": 6
      }
    ],
    "ERROR": 6,
    "EXECUTED": 5,
    "PENDING": 1,
    "REJECTED": 3
  },
  "TradeTypeChoices": {
    "BUY": 2,
    "CHOICES": {
      "1": "Sell",
      "2": "Buy"
    },
    "CHOICE_LIST": [
      {
        "label": "Sell",
        "value": 1
      },
      {
        "label": "Buy",
        "value": 2
      }
    ],
    "SELL": 1
  },
  "TransactionKind": {
    "CHOICES": {
      "1": "Inflow",
      "2": "Outflow"
    },
    "CHOICE_LIST": [
      {
        "label": "Inflow",
        "value": 1
      },
      {
        "label": "Outflow",
        "value": 2
      }
    ],
    "INFLOW": 1,
    "OUTFLOW": 2
  },
  "UploadKind": {
    "AUDIT_REPORT": 16,
    "CHOICES": {
      "1": "Daily Reports Zip",
      "2": "Kotak Timeline Tracking",
      "3": "Management Fee",
      "4": "Performance Fee",
      "5": "Custody Fee",
      "6": "Market Cap",
      "7": "Taxation Report",
      "8": "Entitlement Report",
      "9": "Internal Stock Allocation",
      "10": "Kotak Stock Allocation",
      "11": "Fund Portfolio",
      "12": "FPI Reports",
      "13": "Client Emails",
      "14": "Clients Factsheet",
      "15": "Distributor MIS",
      "16": "Audit Report",
      "17": "Client Signed Audit Report",
      "18": "Clients Trade Master",
      "19": "CML",
      "20": "Client Bank Statement or Cheque",
      "21": "Client Agreement",
      "22": "Client Closure CML",
      "23": "Client Closure Bank Book",
      "24": "Client Bank Book"
    },
    "CHOICE_LIST": [
      {
        "label": "Daily Reports Zip",
        "value": 1
      },
      {
        "label": "Kotak Timeline Tracking",
        "value": 2
      },
      {
        "label": "Management Fee",
        "value": 3
      },
      {
        "label": "Performance Fee",
        "value": 4
      },
      {
        "label": "Custody Fee",
        "value": 5
      },
      {
        "label": "Market Cap",
        "value": 6
      },
      {
        "label": "Taxation Report",
        "value": 7
      },
      {
        "label": "Entitlement Report",
        "value": 8
      },
      {
        "label": "Internal Stock Allocation",
        "value": 9
      },
      {
        "label": "Kotak Stock Allocation",
        "value": 10
      },
      {
        "label": "Fund Portfolio",
        "value": 11
      },
      {
        "label": "FPI Reports",
        "value": 12
      },
      {
        "label": "Client Emails",
        "value": 13
      },
      {
        "label": "Clients Factsheet",
        "value": 14
      },
      {
        "label": "Distributor MIS",
        "value": 15
      },
      {
        "label": "Audit Report",
        "value": 16
      },
      {
        "label": "Client Signed Audit Report",
        "value": 17
      },
      {
        "label": "Clients Trade Master",
        "value": 18
      },
      {
        "label": "CML",
        "value": 19
      },
      {
        "label": "Client Bank Statement or Cheque",
        "value": 20
      },
      {
        "label": "Client Agreement",
        "value": 21
      },
      {
        "label": "Client Closure CML",
        "value": 22
      },
      {
        "label": "Client Closure Bank Book",
        "value": 23
      },
      {
        "label": "Client Bank Book",
        "value": 24
      }
    ],
    "CLIENTS_BANK_BOOK": 24,
    "CLIENTS_FACTSHEET": 14,
    "CLIENTS_SIGNED_AUDIT_REPORT": 17,
    "CLIENTS_TRADE_MASTER": 18,
    "CLIENT_AGREEMENT": 21,
    "CLIENT_BANK_STATEMENT_CHEQUE": 20,
    "CLIENT_CLOSURE_BANK_BOOK": 23,
    "CLIENT_CLOSURE_CML": 22,
    "CLIENT_EMAILS": 13,
    "CML": 19,
    "CUSTODY_FEE": 5,
    "DAILY_REPORTS_ZIP": 1,
    "DISTRIBUTOR_MIS_REPORT": 15,
    "ENTITLEMENT": 8,
    "FPI_REPORTS": 12,
    "FUND_PORTFOLIO": 11,
    "INTERNAL_STOCK_ALLOCATION": 9,
    "KOTAK_STOCK_ALLOCATION": 10,
    "KOTAK_TIMELINE_TRACKING": 2,
    "MANAGEMENT_FEE": 3,
    "MARKET_CAP": 6,
    "PERFORMANCE_FEE": 4,
    "TAXATION": 7
  },
  "UploadStatus": {
    "CHOICES": {
      "1": "Uploading",
      "2": "Uploaded",
      "3": "Processing",
      "4": "Processed",
      "5": "Error"
    },
    "CHOICE_LIST": [
      {
        "label": "Uploading",
        "value": 1
      },
      {
        "label": "Uploaded",
        "value": 2
      },
      {
        "label": "Processing",
        "value": 3
      },
      {
        "label": "Processed",
        "value": 4
      },
      {
        "label": "Error",
        "value": 5
      }
    ],
    "ERROR": 5,
    "PROCESSED": 4,
    "PROCESSING": 3,
    "UPLOADED": 2,
    "UPLOADING": 1
  },
  "UserKind": {
    "ADMIN": 2,
    "CHOICES": {
      "1": "Super Admin",
      "2": "Admin",
      "3": "Client",
      "4": "Distributor"
    },
    "CHOICE_LIST": [
      {
        "label": "Super Admin",
        "value": 1
      },
      {
        "label": "Admin",
        "value": 2
      },
      {
        "label": "Client",
        "value": 3
      },
      {
        "label": "Distributor",
        "value": 4
      }
    ],
    "CLIENT": 3,
    "DISTRIBUTOR": 4,
    "SUPER_ADMIN": 1
  }
};

export default CHOICES;
